module.exports = {
  __depends__: [
    require(52)
  ],
  bpmnImporter: [ 'type', require(6) ]
};